<template>
    <div>
    <v-snackbar v-model="snackbar" color="success" top>
      {{callbackResponse.message}}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogEditCategory" max-width="500px">
      <v-card>
          <v-toolbar class="toolbar-header-color">
              <v-toolbar-title>
                  Edit Category
              </v-toolbar-title>
          </v-toolbar>
        <v-card-text>
          <v-container>
            <form>
              <v-text-field
                v-model="categoryData.name"
                label="Name"
                :error-messages="categoryNameErrors"
                required
                @input="$v.categoryData.name.$touch()"
                @blur="$v.categoryData.name.$touch()"
              ></v-text-field>
            </form>
          </v-container>
        </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="custom-save-button" @click="updateCategory">Save</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditType" max-width="500px">
      <v-card>
          <v-toolbar class="toolbar-header-color">
              <v-toolbar-title>
                  Edit Type
              </v-toolbar-title>
          </v-toolbar>

          <v-card-text>
          <v-container>
            <form>
              <v-text-field
                v-model="typeData.name"
                label="Name"
                :error-messages="typeNameErrors"
                required
                @input="$v.typeData.name.$touch()"
                @blur="$v.typeData.name.$touch()"
              ></v-text-field>
            </form>
          </v-container>
        </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="custom-save-button" @click="updateType">Save</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <deleteListData :deleteFormData="deleteFormData" @formResponse="onResponseDelete"></deleteListData>
    </v-dialog>
    <v-row>
      <v-col>
          <v-row>
            <v-col>
              <v-text-field
                v-model="categoryData.name"
                label="Category"
                :error-messages="categoryNameErrors"
                required
                @input="$v.categoryData.name.$touch()"
                @blur="$v.categoryData.name.$touch()"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                dark
                class="ma-4 float-right"
                @click="createCategory"
              >Add Category</v-btn>
            </v-col>
          </v-row>
          <v-container fluid>
            <vue-good-table
              mode="remote"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              :pagination-options="{ enabled: true, }"
              :rows="categoryRows"
              :columns="columnsRoom"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <v-icon small class="mr-2" @click="editItemCategory(props.row)">edit</v-icon>
                  <v-icon small @click="deleteItemCategory(props.row)">delete</v-icon>
                </span>
              </template>
            </vue-good-table>
          </v-container>
      </v-col>

      <v-col>
          <v-row>
            <v-col>
              <v-text-field
                label="Type"
                v-model="typeData.name"
                :error-messages="typeNameErrors"
                required
                @input="$v.typeData.name.$touch()"
                @blur="$v.typeData.name.$touch()"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn color="primary" dark class="ma-4 float-right" @click="createType">Add Type</v-btn>
            </v-col>
          </v-row>
          <v-container fluid>
            <vue-good-table
              mode="remote"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              :pagination-options="{ enabled: true, }"
              :rows="typeRows"
              :columns="columnsRoom"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <v-icon small class="mr-2" @click="editItemType(props.row)">edit</v-icon>
                  <v-icon small @click="deleteItemType(props.row)">delete</v-icon>
                </span>
              </template>
            </vue-good-table>
          </v-container>
      </v-col>
    </v-row>
    </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import deleteListData from "@/components/deleteModal";
import { parseJwt } from "@/mixins/parseJwt";

export default {
  name: "List",
  mixins: [parseJwt],
  watch: {
    dialog(val) {
      val || this.close();
    },
    success: {
      handler: function(val, oldVal) {
        console.log(val, oldVal);
        this.loadItems();
      },
      deep: true
    }
  },
  computed: {
    categoryNameErrors() {
      const errors = [];
      if (!this.$v.categoryData.name.$dirty) return errors;
      !this.$v.categoryData.name.required && errors.push("Name is required.");
      return errors;
    },
    typeNameErrors() {
      const errors = [];
      if (!this.$v.typeData.name.$dirty) return errors;
      !this.$v.typeData.name.required && errors.push("Name is required.");
      return errors;
    }
  },
  components: {
    deleteListData
  },
  data() {
    return {
      callbackResponse: {
        timeout: 600
      },
      snackbar: false,
      snackbarType: false,
      snackbarError: false,
      snackbarTypeError: false,
      snackbarMessage: "",
      categoryData: {},
      typeData: {},
      success: false,
      dialogCreateRoom: false,
      dialogEditCategory: false,
      dialogEditType: false,
      dialogDelete: false,
      panel: [0],
      deleteFormData: {},
      popout: true,
      isLoading: false,
      columnsRoom: [
        {
          label: "ID",
          field: "id"
        },
        {
          label: "Name",
          field: "name"
        },
        {
          label: "Actions",
          field: "actions",
          sortable: false
        }
      ],
      categoryRows: [],
      typeRows: [],
      totalRecords: 0,
      serverParamsRoom: {
        search: "",
        columnFilters: {},
        sort: [
          {
            field: "id",
            type: "asc"
          }
        ],
        page: 1,
        perPage: 10
      },

      user: [],
      editedIndex: -1,
      editedDataRoom: {}
    };
  },

  mounted() {
    this.loadItemsRoom();
    this.filterData();
  },
  validations: {
    categoryData: {
      name: { required }
    },
    typeData: {
      name: { required }
    }
  },
  destroyed() {
    console.log(this); // There's practically nothing here!
  },
  methods: {
    createCategory() {
      this.$v.categoryData.$touch();
      if (this.$v.categoryData.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "ERROR";
        axios
          .post("Hotel/InsertIntoHotelRoomCategoryAsync", this.categoryData)
          .then((response) => {
            if(response.data.success == true){
              this.categoryData = {};
              this.snackbar = true;
              this.snackbarError = false;
              this.callbackResponse.message="Data Added Successfully"
              setTimeout(function() {
                this.snackbar = false;
              }, 300);
              this.$v.$reset();
              this.loadItemsRoom();
            }
            else{
              this.snackbarError = true;
              this.errorMessage = response.data.errors[0];
               setTimeout(function() {
                this.snackbarError = false;
              }, 300);
            }
          });
      }
    },
    updateCategory() {
      this.$v.categoryData.$touch();
      if (this.$v.categoryData.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        axios
          .post("Hotel/UpdateHotelCategoryAsync", this.categoryData)
          .then(() => {
            this.categoryData = {};
            this.dialogEditCategory = false;
              this.snackbar = true;
              this.snackbarError = false;
              this.callbackResponse.message="Data Updated Successfully"
            this.$v.$reset();

            setTimeout(function() {
              this.snackbar = false;
            }, 300);
            this.loadItemsRoom();
          });
      }
    },
    updateType() {
      this.$v.typeData.$touch();
      if (this.$v.typeData.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        axios.post("Hotel/UpdateHotelTypeAsync", this.typeData).then(() => {
          this.typeData = {};
          this.$v.$reset();
            this.snackbar = true;
            this.snackbarError = false;
            this.callbackResponse.message="Data Updated Successfully"
          setTimeout(function() {
            this.snackbar = false;
          }, 300);
          this.loadItemsRoom();
        });
      }
    },
    createType() {
      this.$v.typeData.$touch();
      if (this.$v.typeData.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        axios
          .post("Hotel/InsertIntoHotelRoomTypeAsync", this.typeData)
          .then((response) => {
            if(response.data.success == true){

            this.typeData = {};
                this.snackbar = true;
                this.snackbarError = false;
            this.callbackResponse.message="Data Added Successfully"

                this.$v.$reset();
            setTimeout(() => {
              this.snackbarType = false;
            }, 500);
            this.loadItemsRoom();
          }
          else{
           this.snackbarTypeError = true;
              this.errorMessage = response.data.errors[0];
              setTimeout(() => {
                this.snackbarTypeError = false;
              }, 300);
            }
      })
      }
    },
    onResponseRoom(data) {
      if (data.status) {
        this.dialogCreateRoom = false;
        this.dialogEditRoom = false;
        this.callbackResponse.message = data.message;
        this.$emit("formResponseRoom", data);
        this.loadItemsRoom();
      }
      else{
        this.dialogDelete = false;
      }
    },
    onResponseDelete(data) {
      console.log("ListRoomDelete", data);
      if (data) {
        this.$emit("formResponseRoomDelete", data);
        this.dialogDelete = false;
        this.loadItemsRoom();
      }
      else{
        this.dialogDelete = false;
      }
    },
    editItemCategory(item) {
      this.editedIndex = this.categoryRows.indexOf(item);
      this.categoryData = Object.assign({}, item);
      this.dialogEditCategory = true;
    },
    editItemType(item) {
      this.editedIndex = this.typeRows.indexOf(item);
      this.typeData = Object.assign({}, item);
      this.dialogEditType = true;
    },

    deleteItemCategory(props) {
      console.log(props);
      this.dialogDelete = true;
      this.deleteFormData.url =
        "Hotel/DeleteHotelRoomCategoryAsync/" + props.id;
    },
    deleteItemType(props) {
      console.log(props);
      this.dialogDelete = true;
      this.deleteFormData.url = "Hotel/DeleteHotelRoomTypeAsync/" + props.id;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedData = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    searchInput() {
      this.loadItems();
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [
          {
            type: params[0].type,
            field: params[0].field
          }
        ]
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    async filterData() {},
    // load items is what brings back the rows from server
    async loadItemsRoom() {
      console.log(this.tokenData);
      // eslint-disable-next-line no-console
      let param = {
        PageSize: this.serverParamsRoom.perPage,
        PageNo: this.serverParamsRoom.page,
        OrderType: this.serverParamsRoom.sort[0].type,
        OrderBy: this.serverParamsRoom.sort[0].field
      };
      try {
        const responseType = await axios.post(
          "Hotel/GetHotelRoomTypeList",
          param
        );
        this.typeRows = responseType.data;
        const responseCategory = await axios.post(
          "Hotel/GetHotelRoomCategoryList",
          param
        );
        this.categoryRows = responseCategory.data;
        // this.totalRecords = response.data.totalCount;
      } catch (e) {
        if (e.response.data.State == "AccessTokenExpired") {
          this.apiResponse(e);
          this.loadItems();
        }
      }
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-item-group {
  background: #d2e3ff73;
}
.v-expansion-panel-header {
  background: #d2e3ff73;
}
button {
  z-index: 1;
}
</style>
